import {LocationQueryRaw} from "vue-router";

class QueryBuilder {
    public static MAX: number = 10000000;

    private query: LocationQueryRaw = {};

    dateFrom(dateFrom: string) {
        this.query.dateFrom = dateFrom;
        return this;
    }

    dateTo(dateTo: string) {
        this.query.dateTo = dateTo;
        return this;
    }

    dateRange(dateFrom: string, dateTo: string): this {
        this.query.dateFrom = dateFrom;
        this.query.dateTo = dateTo;
        return this;
    }

    price(min: number, max: number): this {
        this.query.minPrice = min;
        this.query.maxPrice = max;
        return this;
    }

    cabins(min: number, max: number): this {

        this.query.minCabins = min;
        this.query.maxCabins = max;
        return this;
    }

    years(min: number, max: number): this {
        this.query.minBuildYear = min;
        this.query.maxBuildYear = max;
        return this;
    }

    wc(min: number, max: number): this {
        this.query.minHeads = min;
        this.query.maxHeads = max;
        return this;
    }

    berths(min: number, max: number): this {
        this.query.minBerths = min;
        this.query.maxBerths = max;
        return this;
    }

    length(min: number, max: number): this {
        this.query.minLength = min;
        this.query.maxLength = max;
        return this;
    }

    charterTypeIds(charterTypes): this {
        this.query.charterTypeId = charterTypes;
        return this;
    }

    sailTypeIds(sailTypes: number[]): this {
        this.query.sailTypeIds = sailTypes;
        return this;
    }

    modelIds(models: number[]): this {
        this.query.yachtModelIds = models;
        return this;
    }

    shipyardIds(shipyards: number[]): this {
        this.query.shipyardIds = shipyards;
        return this;
    }

    categoryIds(categories: number[]): this {
        this.query.yachtCategoryIds = categories;
        return this;
    }

    regionIds(regions: number[]): this {
        this.query.regionIds = regions;
        return this;
    }

    countryIds(countries: number[]): this {
        this.query.countryIds = countries;
        return this;
    }

    locationIds(locations: number[]): this {
        this.query.locationIds = locations;
        return this;
    }

    cityIds(cities: number[]): this {
        this.query.cityIds = cities;
        return this;
    }

    sortBy(sortBy: string, order: 'asc' | 'desc'): this {
        this.query.sort = `${sortBy},${order}`;
        return this;
    }

    passengers(passengers: number): this {
        this.query.passengers = passengers;
        return this;
    }

    skipper(hasSkipper: boolean): this {
        this.query.skipper = hasSkipper ? "true" : "false";
        return this;
    }

    build(recommend: boolean = false, mappedNames: any = {}): Record<string, any> {

        const params = {}
        for (const key in this.query) {


            if (Array.isArray(this.query[key]) && this.query[key].length <= 0) {
                continue
            }
            if (typeof this.query[key] === "object" && !this.query[key]) {
                continue
            }

            if (typeof this.query[key] === "number" && this.query[key] <= 0 && key !== 'passengers' && key !== 'skipper') {
                continue
            }


            if (typeof this.query[key] === "number" && this.query[key] >= QueryBuilder.MAX) {
                continue
            }


            if (recommend && key in ['maxCabins', 'sort']) {
                continue
            }

            let value = this.query[key];

            if (Array.isArray(this.query[key]) && this.query[key].length === 1) {
                value = value[0]
            }

            let insertKey = key

            if (key in mappedNames) {
                insertKey = mappedNames[key]
            }

            params[insertKey] = value

        }


        return params

    }
}

export default QueryBuilder;
